import IbkNoticeBox from "@/components/ibk/IbkNoticeBox.vue";
// NZSC-3650: 로그인 가드는 토큰 "존재"가 아니라 세션 확보 가능 여부로 판정한다
import { ensureSession, requireSession } from "@/utils/sessionGuard";

//---------------------
//분석
//---------------------
const analyzeRouter = [
  {
    path: "/analyze",
    name: "analyze",
    component: () => import("../views/analyze/AnalyzeHome.vue"),
  },
  // NZSC-3194: 단톡방 바이럴 전용 진입점 — UTM은 티가 나서 별도 URL로 유입 식별.
  // /analyze와 동일 화면, AnalyzeHome created()에서 entry_channel super property 등록
  {
    path: "/landing",
    name: "landing",
    component: () => import("../views/analyze/AnalyzeHome.vue"),
  },
  // NZSC-3222: 전월세(월세/반전세) 광고 유입 전용 랜딩
  {
    path: "/landing/monthly",
    name: "landing-monthly",
    component: () => import("../views/analyze/MonthlyLandingView.vue"),
  },
  {
    path: "/analyze/type",
    name: "analyze-type",
    component: () => import("../views/analyze/AnalyzeType.vue"),
  },
  {
    path: "/analyze/period",
    name: "analyze-period",
    component: () => import("../views/analyze/AnalyzePeriod.vue"),
  },
  {
    path: "/analyze/period-detail",
    name: "analyze-period-detail",
    component: () => import("../views/analyze/AnalyzePeriodDetail.vue"),
  },
  {
    path: "/analyze/section",
    name: "analyze-section",
    component: () => import("../views/analyze/AnalyzeSection.vue"),
  },
  {
    path: "/analyze/area",
    name: "analyze-area",
    component: () => import("../views/analyze/AnalyzeAddress.vue"),
  },
  {
    path: "/analyze/price",
    name: "analyze-price",
    component: () => import("../views/analyze/AnalyzePrice.vue"),
  },
  {
    path: "/analyze/date",
    name: "analyze-date",
    component: () => import("../views/analyze/AnalyzeDate.vue"),
  },
  {
    path: "/analyze/date/living",
    name: "analyze-date-living",
    component: () => import("../views/analyze/AnalyzeDateLiving.vue"),
  },
  {
    path: "/analyze/address",
    name: "analyze-address",
    component: () => import("../views/analyze/Analyze.vue"),
  },
  {
    path: "/analyze/search",
    name: "analyze-search",
    component: () => import("../views/analyze/AnalyzeSearch.vue"),
  },
  {
    path: "/analyze/faq",
    name: "analyze-faq",
    component: () => import("../views/analyze/AnalyzeFaq.vue"),
  },
  {
    path: "/analyze/faq-area",
    name: "analyze-faq-area",
    component: () => import("../views/analyze/AnalyzeFaqArea.vue"),
  },
  // NZSC-3221: 걱정점(faq-area) 단계를 대체하는 궁금한 점 자유입력 화면 (전월세 전용)
  {
    path: "/analyze/qna",
    name: "analyze-qna",
    component: () => import("../views/analyze/AnalyzeQna.vue"),
  },
  {
    path: "/analyze/cash",
    name: "analyze-cash",
    component: () => import("../views/analyze/AnalyzeCash.vue"),
  },
  {
    path: "/analyze/firstrepay",
    name: "analyze-firstrepay",
    component: () => import("../views/analyze/AnalyzeFirstRepay.vue"),
  },
  {
    path: "/analyze/extension",
    name: "analyze-faq-extension",
    component: () => import("../views/analyze/AnalyzeFaqExtension.vue"),
  },
  {
    path: "/analyze/faqwrite",
    name: "analyze-faqwrite",
    component: () => import("../views/analyze/AnalyzeFaqWrite.vue"),
  },
  {
    path: "/analyze/loan",
    name: "analyze-loan",
    component: () => import("../views/analyze/AnalyzeLoan.vue"),
  },
  {
    path: "/analyze/amount",
    name: "analyze-amount",
    component: () => import("../views/analyze/AnalyzeAmount.vue"),
    beforeEnter: requireSession,
  },
  {
    path: "/analyze/pay-complete",
    name: "analyze-pay-complete",
    component: () => import("../views/analyze/AnalyzePayComplete.vue"),
    beforeEnter: requireSession,
  },
  {
    path: "/analyze/address-search",
    name: "analyze-address-search",
    component: () => import("../components/address/Search.vue"),
    beforeEnter: requireSession,
  },
  {
    path: "/analyze/complete",
    name: "analyze-complete",
    component: () => import("../views/analyze/AnalyzeComplete.vue"),
    beforeEnter: requireSession,
  },
  {
    path: "/analyze/ticket-complete",
    name: "analyze-ticket-complete",
    component: () => import("../views/analyze/AnalyzeTicketComplete.vue"),
    beforeEnter: requireSession,
  },
  {
    path: "/analyze/freebase",
    name: "analyze-freebase",
    component: () => import("../views/analyze/AnalyzeFreeBase.vue"),
  },
  {
    path: "/analyze/freelogin",
    name: "analyze-freelogin",
    component: () => import("../views/analyze/AnalyzeFreeLogin.vue"),
  },
  {
    path: "/analyze/report-login",
    name: "analyze-report-login",
    component: () => import("../views/analyze/AnalyzeReportLogin.vue"),
  },
  {
    path: "/analyze/free",
    name: "analyze-free",
    component: () => import("../views/analyze/AnalyzeFreeReport.vue"),
    beforeEnter: requireSession,
  },
  {
    path: "/analyze/error",
    name: "analyze-error",
    component: () => import("../views/AnalyzeError.vue"),
  },
  {
    path: "/analyze/realtor-price",
    name: "analyze-faq-realtorprice",
    component: () => import("../views/analyze/AnalyzeFaqRealtorPrice.vue"),
  },
  {
    path: "/analyze/realtor-price-reason",
    name: "analyze-faq-realtorprice-reason",
    component: () => import("../views/analyze/AnalyzeFaqRealtorPriceReason.vue"),
  },
  {
    path: "/analyze/amount/review",
    name: "analyze-amount-review",
    component: () => import("../views/amount/AmountReviewView.vue"),
    beforeEnter: requireSession,
  },

  //이어하기
  {
    path: "/analyze/continue-report",
    name: "analyze-continue-report",
    component: () => import("../views/analyze/AnalyzeReportContinueView.vue"),
  },
  {
    path: "/analyze/continue-subscribe",
    name: "analyze-continue-subscribe",
    component: () => import("../views/analyze/AnalyzeSubscribeContinueView.vue"),
  },

  //전세대출
  {
    path: "/analyze/loan-amount",
    name: "loan-amount",
    component: () => import("../views/a-b/AnalyzeLoanAmountView.vue"),
    beforeEnter: requireSession,
  },

  // IBK 전용 라우터(-ione)
  {
    path: "/analyze/kakao-login-ione",
    name: "analyze-kakao-login-ione",
    component: () => import("../views/ibk/IbkAnalyzeKakaoLogin.vue"),
  },
  {
    path: "/analyze/valid-campaign-ione",
    name: "analyze-valid-campaign-ione",
    component: () => import("../views/ibk/IbkAnalyzeValid.vue"),
  },
  {
    path: "/analyze/amount-ione",
    name: "analyze-amount-ione",
    component: () => import("../views/ibk/IbkAnalyzeAmount.vue"),
  },
  {
    path: "/analyze-ione",
    name: "analyze-ione",
    component: () => import("../views/ibk/IbkAnalyzeHome.vue"),
  },
  {
    path: "/analyze/type-ione",
    name: "analyze-type-ione",
    component: () => import("../views/analyze/AnalyzeType.vue"),
  },
  {
    path: "/analyze/search-ione",
    name: "analyze-search-ione",
    component: () => import("../views/analyze/AnalyzeSearch.vue"),
  },
  {
    path: "/analyze/address-ione",
    name: "analyze-address-ione",
    component: () => import("../views/analyze/Analyze.vue"),
  },
  {
    path: "/analyze/price-ione",
    name: "analyze-price-ione",
    component: () => import("../views/analyze/AnalyzePrice.vue"),
  },
  {
    path: "/analyze/cash-ione",
    name: "analyze-cash-ione",
    component: () => import("../views/analyze/AnalyzeCash.vue"),
  },
  {
    path: "/analyze/firstrepay-ione",
    name: "analyze-firstrepay-ione",
    component: () => import("../views/analyze/AnalyzeFirstRepay.vue"),
  },
  {
    path: "/analyze/period-ione",
    name: "analyze-period-ione",
    component: () => import("../views/analyze/AnalyzePeriod.vue"),
  },
  {
    path: "/analyze/period-detail-ione",
    name: "analyze-period-detail-ione",
    component: () => import("../views/analyze/AnalyzePeriodDetail.vue"),
  },
  {
    path: "/analyze/section-ione",
    name: "analyze-section-ione",
    component: () => import("../views/analyze/AnalyzeSection.vue"),
  },
  {
    path: "/analyze/area-ione",
    name: "analyze-area-ione",
    component: () => import("../views/analyze/AnalyzeAddress.vue"),
  },
  {
    path: "/analyze/date-ione",
    name: "analyze-date-ione",
    component: () => import("../views/analyze/AnalyzeDate.vue"),
  },
  {
    path: "/analyze/date/living-ione",
    name: "analyze-date-living-ione",
    component: () => import("../views/analyze/AnalyzeDateLiving.vue"),
  },
  {
    path: "/analyze/faq-ione",
    name: "analyze-faq-ione",
    component: () => import("../views/analyze/AnalyzeFaq.vue"),
  },
  {
    path: "/analyze/faq-area-ione",
    name: "analyze-faq-area-ione",
    component: () => import("../views/analyze/AnalyzeFaqArea.vue"),
  },
  {
    path: "/analyze/address-search-ione",
    name: "analyze-address-search-ione",
    component: () => import("../components/address/Search.vue"),
    beforeEnter: requireSession,
  },
  {
    path: "/analyze/complete-ione",
    name: "analyze-complete-ione",
    component: () => import("../views/analyze/AnalyzeComplete.vue"),
    beforeEnter: requireSession,
  },
  {
    path: "/analyze/report-login-ione",
    name: "analyze-report-login-ione",
    component: () => import("../views/analyze/AnalyzeReportLogin.vue"),
  },

  // 매매 리포트 분쟁사례 페이지.
  {
    path: "/analyze/buy-conflicts",
    name: "analyze-buy-conflicts",
    component: () => import("../views/analyze/AnalyzeBuyReportConflictCasesView.vue"),
    beforeEnter: requireSession,
  },

  // 피터팬 진입점 - B안 채택으로 amount 페이지로 리다이렉트
  // 로그인 상태: amount 페이지로 이동
  // 비로그인 상태: 로그인 유도 페이지로 이동
  {
    path: "/analyze/peterpanz",
    beforeEnter: async (to, from, next) => {
      if (await ensureSession()) {
        next("/analyze/amount?provider=peterpanz");
      } else {
        next("/analyze/freelogin?provider=peterpanz");
      }
    },
    // redirect 제거하고 beforeEnter에서 직접 분기 처리
    component: () => import("../views/analyze/AnalyzeAmount.vue"),
  },

  // 상세주소 재입력 (알림톡 링크 진입)
  {
    path: "/address/reinput",
    name: "address-reinput",
    component: () => import("../components/address/AddressReinput.vue"),
    beforeEnter: async (to, from, next) => {
      if (await ensureSession()) {
        next();
      } else {
        const merchant = to.query.merchant || "";
        const address = to.query.address || "";
        next(`/login?state=${encodeURIComponent(`address_reinput|${merchant}|${address}`)}`);
      }
    },
  },
];

export default analyzeRouter;
